<template>
  <div class="hello">
    <div class="search">
      <input @input="searchDemandes(currentPage)" v-model="searchTerm" type="text" placeholder="Rechercher une demande...">
      <select @change="searchDemandes(currentPage)"  v-model="selectedMotif">
        <option value="">Motifs</option>
        <option v-for="motif in motifs" :key="motif.id" :value="motif.motif">{{ motif.motif }}</option>
      </select>
    </div>    
    <div v-if="nb_pages > 1" class="pagination container">
      <div class="pagination-pages">
        <span>Page:</span>
        <select @change="searchDemandes(parseInt($event.target.value))">
          <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
        </select>
        <span>sur {{ nb_pages }}</span>
      </div>
    </div>
    <div v-if="confirmationMessage" class="alert alert-success" role="alert">
      {{ confirmationMessage }}
  </div>
    <div class="links container-fluid">
      <RouterLink to="/demandes"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-archive-fill" viewBox="0 0 16 16">
      <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"/>
      </svg>Retour aux demandes en cours</RouterLink>
    </div>
    <div class="containerTab" style="overflow: auto;">
      <div class="table-responsive-modern">
        <table class="demandesListeModern">
        <thead>
          <tr>
            <th>Code (article ou affaire)</th>
            <th>Motif</th>
            <th>Commentaire</th>
            <th>Images jointes</th>
            <th>Signalé par</th>
            <th>Signalé le</th>
            <th>Archivé par</th>
            <th>Archivé le</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="demandesFiltered.length === 0">
            <tr>
              <td colspan="8" class="text-center">Pas de résultats dans les archives.</td>
            </tr>
          </template>
          <template v-else>
            <tr v-for="demande in demandesFiltered" :key="demande.id" class="demandes">
              <td>{{ demande.article }}</td>
              <td>{{ demande.motif }}</td>
              <td style="width:40%; text-align:justify;">{{ demande.commentaire }}</td>
              <td style="max-width: 400px;">
                <div class="thumbnails-modern">
                  <div v-for="(file, index) in demande.sources_images" :key="index" @click="openFilePopup(file)" class="file-item-modern">
                    <img v-if="isImage(file)" :src="file" alt="Image" class="file-thumbnail-modern">
                    <div v-else class="pdf-icon-modern">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-file-earmark-pdf" viewBox="0 0 16 16">
                        <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                        <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.816.024.111.054.227.09.352z"/>
                      </svg>
                      <span>PDF</span>
                    </div>
                  </div>
                </div>
              </td>
              <td>{{ demande.utilisateur }}</td>
              <td>{{ demande.date }}</td>
              <td>{{ demande.archive_par }}</td>
              <td>{{ demande.archive_le }}</td>
            </tr>
          </template>
        </tbody>
        </table>
      </div>
    </div>
    
    <div v-if="nb_pages > 1" class="pagination container">
      <div class="pagination-pages">
        <span>Page:</span>
        <select @change="searchDemandes(parseInt($event.target.value))">
          <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
        </select>
        <span>sur {{ nb_pages }}</span>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="loader">
      <div id="loading"></div>
    </div>
  </div>

  <div v-if="showFileViewer" class="file-upload-form" @click="closePopup">
    <div class="file-upload-form-content" @click.stop>
      <a class="close-button" @click="closePopup">&times;</a>
      <!-- Afficher le fichier selon son type -->
      <img v-if="isImage(linkFile)" :src="linkFile" alt="Image"/>
      <iframe v-else :src="linkFile" class="pdf-viewer"></iframe>
    </div>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'



export default {
  data() {
    return {
      demandes: [],
      motifs: [],
      nb_pages:1,
      currentPage: 1,
      archive: 1,
      searchTerm: '',
      selectedMotif: '',
      isLoading: false,
      confirmationMessage: '',
      showFileViewer: false,
    }
  },
  mounted() {
    

      this.currentPage = parseInt(this.$route.query.page) || 1;
      this.searchTerm = this.$route.query.searchTerm || '';
      this.selectedMotif = this.$route.query.selectedMotif || '';

      this.searchDemandes(this.currentPage);


      axios.get('https://www.simef.fr/espace-client/api/getMotifs.php?archive=1')
      .then(response => {
        this.motifs = response.data;
      })
      .catch(error => {
        console.error(error);
        
      });
  }, 
  computed: {
    demandesFiltered() {
      return this.demandes.filter(demande => demande.archive !== 1);
    },
  },
  watch: {
    $route(to) {
      this.currentPage = parseInt(to.query.page) || 1;
      this.searchTerm = to.query.searchTerm || '';
      this.selectedMotif = to.query.selectedMotif || '';

      this.searchDemandes(this.currentPage);
    }

    
  },
  methods: {
    searchDemandes(page) {
      this.isLoading = true; // Show loader
      axios.get(`https://www.simef.fr/espace-client/api/getDemandesArchive.php?page=${page}&searchTerm=${this.searchTerm}&selectedMotif=${this.selectedMotif}`)
        .then(response => {
          this.demandes = response.data.demandes;
          this.nb_pages = response.data.nb_pages;
          this.currentPage = page;
        })
        .catch(error => {
          console.error(error);
          
        })
        .finally(() => {
          this.isLoading = false; // Hide loader
        });

        this.$router.push({
          query: {
            page: page,
            searchTerm: this.searchTerm,
            selectedMotif: this.selectedMotif,
          }
        });
    },
    formatDate(date) {
      // Extraire les parties de la date
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 2);

      // Concaténer les parties dans l'ordre souhaité
      const formattedDate = `${day}-${month}-${year}`;

      // Renvoyer la date formatée
      return formattedDate;
    },
    archiverDemande(demande) {
      if (confirm("Êtes-vous sûr de vouloir archiver cette demande ?")) {
        axios
          .post('https://www.simef.fr/espace-client/api/archiverDemande.php', {
            article: demande.article,
            utilisateur: demande.utilisateur,
            motif: demande.motif,
          })
          .then(response => {
            this.confirmationMessage = response.data.success;
            // Remove the archived demande from the demandes array
            const index = this.demandes.indexOf(demande);
            if (index !== -1) {
              this.demandes.splice(index, 1);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    closePopup(event) {
      event.stopPropagation();
      this.showFileViewer = false;
    },
    openFilePopup(item) {
      this.showFileViewer = !this.showFileViewer;
      this.linkFile = item;
    },
    isImage(fileUrl) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
      const extension = fileUrl.toLowerCase().substring(fileUrl.lastIndexOf('.'));
      return imageExtensions.includes(extension);
    },
   isPdf(fileUrl) {
      return fileUrl.toLowerCase().endsWith('.pdf');
    },
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $primary: #2b358d;
  select {
    background: #f5f5f5;
    border: 0px;
    padding: 12px 15px;
    border: 1px solid lightgrey;
    margin-right: 10px;
  }
  #loading {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 3px solid rgba(255,255,255,.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
  }
  
  @keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  @-webkit-keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  button {
    background: $primary;
    border: none;
    padding: 12px 20px;
    color: #fff;
  }
  .check {
    margin-right: 10px;
  }
 

  table.demandesListe {
    width: 100%;
    tbody {
    
      a {
        font-size: 0.9rem;
        color: #2b358d;
        display: contents;
      }
    }
    thead {
      background: #333;
      color: #fff;
      position: sticky;
      top: 0px;
    }
    th, td {
      padding: 8px;
      font-size: 0.9rem;
      font-weight: 500;
    }
    .ligne-claire {
      background-color: #f7f7f7;
    }
    .ligne-foncee {
      background-color: #ebebeb;
    }
  }
  
  .search {
      margin-bottom: 5px!important;
      @media screen and (max-width:992px) {
        input[type="text"] {
            margin-bottom: 10px;
        }
      }
  }


  .text-danger {
    color: rgb(255, 17, 17);
  }
  .search {
    input[type="text"], select {
        background: #f5f5f5;
        border: 0px;
        padding: 12px 20px;
        border: 1px solid lightgrey;
        margin-right: 10px;
        &:focus-visible {
          outline: $primary auto 1px;
          border-color: $primary;
          border-radius: 0px;
        }
    }
  }
  .loader {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #0b0b0baa;
    top: 0;
    left: 0;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
z-index: 99999;
  }
  .archiver {
    a {
      height: 100%;
      width: 100%;
      display: flex!important;
      align-items: center;
      justify-content: center;
      svg {
        margin-right: 5px;
        height: 18px;
        widows: 18px;
      }
    }
  }
  .table-responsive-modern {
    width: 100%;
    overflow-x: auto;
    margin-top: 24px;
  }
  table.demandesListeModern {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    background: #fff;
    box-shadow: 0 2px 16px rgba(43,53,141,0.07);
    overflow: hidden;
    thead {
      background: $primary;
      color: #fff;
      position: sticky;
      top: 0;
      th {
        padding: 14px 10px;
        font-size: 1rem;
        font-weight: 700;
        color: #fff;
        background: $primary;
        border-top: none;
        border-bottom: 2px solid #e0e0e0;
      
      }
    }
    tbody {
      tr {
        transition: background 0.15s;
        &:hover {
          background: #f0f4fa;
        }
      }
      td {
        padding: 13px 10px;
        font-size: 0.98rem;
        font-weight: 500;
        border-bottom: 1px solid #f0f0f0;
        vertical-align: middle;
      }
    }
    .ligne-claire {
      background-color: #f9f9fb;
    }
    .ligne-foncee {
      background-color: #ebebeb;
    }
  }
  .thumbnails-modern {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 7px;
    justify-content: flex-start;
    .file-item-modern {
      cursor: pointer;
      border: 1px solid #e0e0e0;
      border-radius: 6px;
      overflow: hidden;
      background: #f7f7f7;
      transition: transform 0.15s;
      &:hover {
        transform: scale(0.96);
      }
      .file-thumbnail-modern {
        height: 40px;
        width: 40px;
        object-fit: cover;
        display: block;
      }
      .pdf-icon-modern {
        height: 40px;
        width: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: #f8f9fa;
        color: #dc3545;
        svg {
          width: 18px;
          height: 18px;
          margin-bottom: 2px;
        }
        span {
          font-size: 8px;
          font-weight: bold;
        }
      }
    }
  }
</style>
